<script setup lang="ts">
import { translate } from '@/shared/i18n';
import { Popup } from '@/shared/ui';

import { MessageDeleteTemplate } from './templates';

const opened = defineModel<boolean>('opened', { default: false });
</script>

<template>
  <Popup
    v-model:show="opened"
    overlay
  >
    <MessageDeleteTemplate>
      <template #text>
        <div class="text-primary">{{ translate('message.deleteConfirmation') }}</div>
      </template>

      <template #buttons>
        <slot name="buttons" />
      </template>
    </MessageDeleteTemplate>
  </Popup>
</template>
